import { createIconComponent } from './createIconComponent';
import { ReactComponent as IconAddress } from './svg/address.svg';
import { ReactComponent as IconAlpaca } from './svg/alpaca.svg';
import { ReactComponent as IconArrow } from './svg/arrow.svg';
import { ReactComponent as IconArt } from './svg/art.svg';
import { ReactComponent as IconBallon } from './svg/ballon.svg';
import { ReactComponent as IconBell } from './svg/bell.svg';
import { ReactComponent as IconBrokenLink } from './svg/brokenLink.svg';
import { ReactComponent as IconBurgerMenu } from './svg/burgerMenu.svg';
import { ReactComponent as IconCalendar } from './svg/calendar.svg';
import { ReactComponent as IconCalendarCheck } from './svg/calendarCheck.svg';
import { ReactComponent as IconCalendarWithDates } from './svg/calendarWithDates.svg';
import { ReactComponent as IconCalendarWithGear } from './svg/calendarWithGear.svg';
import { ReactComponent as IconCatalog } from './svg/catalog.svg';
import { ReactComponent as IconCheck } from './svg/check.svg';
import { ReactComponent as IconCheckCircle } from './svg/checkCircle.svg';
import { ReactComponent as IconCheckMarkLock } from './svg/checkMarkLock.svg';
import { ReactComponent as IconChevron } from './svg/chevron.svg';
import { ReactComponent as IconClock } from './svg/clock.svg';
import { ReactComponent as IconClockFilled } from './svg/clockFilled.svg';
import { ReactComponent as IconClose } from './svg/close.svg';
import { ReactComponent as IconClubDiscount } from './svg/clubDiscount.svg';
import { ReactComponent as IconCopy } from './svg/copy.svg';
import { ReactComponent as IconCurvedArrow } from './svg/curvedArrow.svg';
import { ReactComponent as IconDescription } from './svg/description.svg';
import { ReactComponent as IconDinner } from './svg/dinner.svg';
import { ReactComponent as IconDownload } from './svg/download.svg';
import { ReactComponent as IconEarthOutline } from './svg/earthOutline.svg';
import { ReactComponent as IconEmailMonitor } from './svg/email-monitor.svg';
import { ReactComponent as IconEmailPhone } from './svg/email-phone.svg';
import { ReactComponent as IconExclamationTriangle } from './svg/exclamationTriangle.svg';
import { ReactComponent as IconEye } from './svg/eye.svg';
import { ReactComponent as IconEyeClosed } from './svg/eyeClosed.svg';
import { ReactComponent as IconFaq } from './svg/faq.svg';
import { ReactComponent as IconFilter } from './svg/filter.svg';
import { ReactComponent as IconFilterHorizontal } from './svg/filterHorizontal.svg';
import { ReactComponent as IconFireworks } from './svg/fireworks.svg';
import { ReactComponent as IconFlagInfo } from './svg/flagInfo.svg';
import { ReactComponent as IconFly } from './svg/fly.svg';
import { ReactComponent as IconForwardClock } from './svg/forwardClock.svg';
import { ReactComponent as IconGiftWrapping } from './svg/giftwrapping.svg';
import { ReactComponent as IconGlobe } from './svg/globe.svg';
import { ReactComponent as IconHalfClock } from './svg/halfClock.svg';
import { ReactComponent as IconHeadset } from './svg/headset.svg';
import { ReactComponent as IconHealth } from './svg/health.svg';
import { ReactComponent as IconHeart } from './svg/heart.svg';
import { ReactComponent as IconHeartFilled } from './svg/heartFilled.svg';
import { ReactComponent as IconSignpost } from './svg/iconSignpost.svg';
import { ReactComponent as IconInfo } from './svg/info.svg';
import { ReactComponent as IconInfoOutline } from './svg/infoOutline.svg';
import { ReactComponent as IconLamp } from './svg/lamp.svg';
import { ReactComponent as IconLayer } from './svg/layer.svg';
import { ReactComponent as IconListView } from './svg/listView.svg';
import { ReactComponent as IconLiveLocation } from './svg/liveLocationIcon.svg';
import { ReactComponent as IconLocationDetails } from './svg/location-details.svg';
import { ReactComponent as IconLock } from './svg/lock.svg';
import { ReactComponent as IconLogout } from './svg/logout.svg';
import { ReactComponent as IconMail } from './svg/mail.svg';
import { ReactComponent as IconMessage } from './svg/mailOutline.svg';
import { ReactComponent as IconMap } from './svg/map.svg';
import { ReactComponent as IconMapMarker } from './svg/mapMarker.svg';
import { ReactComponent as IconMaximize } from './svg/maximize.svg';
import { ReactComponent as IconNavigation } from './svg/navigation.svg';
import { ReactComponent as IconNotAvailable } from './svg/notAvailable.svg';
import { ReactComponent as IconNotificationAlert } from './svg/notificationAlert.svg';
import { ReactComponent as IconOliveLeaf } from './svg/oliveLeaf.svg';
import { ReactComponent as IconPaint } from './svg/paint.svg';
import { ReactComponent as IconPdf } from './svg/pdf.svg';
import { ReactComponent as IconPdfCheck } from './svg/pdfCheck.svg';
import { ReactComponent as IconPencil } from './svg/pencil.svg';
import { ReactComponent as IconPhone } from './svg/phone.svg';
import { ReactComponent as IconPhoneOutline } from './svg/phoneOutline.svg';
import { ReactComponent as IconPlus } from './svg/plus.svg';
import { ReactComponent as IconPrice } from './svg/price.svg';
import { ReactComponent as IconPriceFranc } from './svg/priceFranc.svg';
import { ReactComponent as IconProfile } from './svg/profile.svg';
import { ReactComponent as IconQrCode } from './svg/qrCode.svg';
import { ReactComponent as IconQuestion } from './svg/question.svg';
import { ReactComponent as IconRedirect } from './svg/redirectIcon.svg';
import { ReactComponent as IconReturn } from './svg/return.svg';
import { ReactComponent as IconReturnArrow } from './svg/returnArrow.svg';
import { ReactComponent as IconReview } from './svg/review.svg';
import { ReactComponent as IconSailboat } from './svg/sailboat.svg';
import { ReactComponent as IconScreen } from './svg/screen.svg';
import { ReactComponent as IconSearch } from './svg/search.svg';
import { ReactComponent as IconSettings } from './svg/settings.svg';
import { ReactComponent as IconShare } from './svg/share.svg';
import { ReactComponent as IconShoppingCart } from './svg/shoppingCart.svg';
import { ReactComponent as IconSmileyHappy } from './svg/smileyHappy.svg';
import { ReactComponent as IconSmileyIndifferent } from './svg/smileyIndifferent.svg';
import { ReactComponent as IconSmileySad } from './svg/smileySad.svg';
import { ReactComponent as IconSmileySmirk } from './svg/smileySmirk.svg';
import { ReactComponent as IconSmileyUnhappy } from './svg/smileyUnhappy.svg';
import { ReactComponent as IconFacebook } from './svg/social/facebook.svg';
import { ReactComponent as IconInstagram } from './svg/social/instagram.svg';
import { ReactComponent as IconPinterest } from './svg/social/pinterest.svg';
import { ReactComponent as IconTiktok } from './svg/social/tiktok.svg';
import { ReactComponent as IconWhatsApp } from './svg/social/whatsApp.svg';
import { ReactComponent as IconYoutube } from './svg/social/youtube.svg';
import { ReactComponent as IconSorting } from './svg/sorting.svg';
import { ReactComponent as IconSport } from './svg/sport.svg';
import { ReactComponent as IconStar } from './svg/star.svg';
import { ReactComponent as IconSteeringWheel } from './svg/steeringWheel.svg';
import { ReactComponent as IconSupport } from './svg/supportIcon.svg';
import { ReactComponent as IconSurf } from './svg/surf.svg';
import { ReactComponent as IconTent } from './svg/tent.svg';
import { ReactComponent as IconThumb } from './svg/thumb.svg';
import { ReactComponent as IconThumbOutline } from './svg/thumbOutline.svg';
import { ReactComponent as IconTicket } from './svg/ticket.svg'; // We have two the same ticketTwo icons but with different line thickness because we have two different use cases
import { ReactComponent as IconTicketDetails } from './svg/ticketDetails.svg';
import { ReactComponent as IconTicketExchange } from './svg/ticketExchange.svg';
import { ReactComponent as IconTicketsOutlineThick } from './svg/ticketsOutlineThick.svg';
import { ReactComponent as IconTicketsOutlineThin } from './svg/ticketsOutlineThin.svg';
import { ReactComponent as IconTicketWithValue } from './svg/ticketWithValue.svg';
import { ReactComponent as IconTileView } from './svg/tileView.svg';
import { ReactComponent as IconTouch } from './svg/touch.svg';
import { ReactComponent as IconTrampoline } from './svg/trampoline.svg';
import { ReactComponent as IconTrash } from './svg/trash.svg';
import { ReactComponent as IconTravel } from './svg/travel.svg';
import { ReactComponent as IconTrip } from './svg/trip.svg';
import { ReactComponent as IconTripBold } from './svg/tripBold.svg';
import { ReactComponent as IconUser } from './svg/user.svg';
import { ReactComponent as IconUserCouple } from './svg/userCouple.svg';
import { ReactComponent as IconUserGroup } from './svg/userGroup.svg';
import { ReactComponent as IconOutlineUser } from './svg/userOutline.svg';
import { ReactComponent as IconOutlineUserFilled } from './svg/userOutlineFilled.svg';
import { ReactComponent as IconVarity } from './svg/varity.svg';
import { ReactComponent as IconWarrantyBadge } from './svg/warrantyBadge.svg';
import { ReactComponent as IconWaterSports } from './svg/waterSports.svg';
import { ReactComponent as IconWaypoint } from './svg/waypoint.svg';
export const ArrowIcon = /* #__PURE__ */ createIconComponent(IconArrow);
export const BellIcon = /* #__PURE__ */ createIconComponent(IconBell);
export const AddressIcon = /* #__PURE__ */ createIconComponent(IconAddress);
export const BrokenLinkIcon = /* #__PURE__ */ createIconComponent(IconBrokenLink);
export const BurgerMenuIcon = /* #__PURE__ */ createIconComponent(IconBurgerMenu);
export const CalendarCheckIcon = /* #__PURE__ */ createIconComponent(IconCalendarCheck);
export const CalendarIcon = /* #__PURE__ */ createIconComponent(IconCalendar);
export const CalendarWithDatesIcon = /* #__PURE__ */ createIconComponent(IconCalendarWithDates);
export const CalendarWithGearIcon = /* #__PURE__ */ createIconComponent(IconCalendarWithGear);
export const CatalogIcon = /* #__PURE__ */ createIconComponent(IconCatalog);
export const CheckCircleIcon = /* #__PURE__ */ createIconComponent(IconCheckCircle);
export const CheckIcon = /* #__PURE__ */ createIconComponent(IconCheck);
export const ChevronIcon = /* #__PURE__ */ createIconComponent(IconChevron);
export const ClockIcon = /* #__PURE__ */ createIconComponent(IconClock);
export const ClockFilledIcon = /* #__PURE__ */ createIconComponent(IconClockFilled);
export const CloseIcon = /* #__PURE__ */ createIconComponent(IconClose);
export const CopyIcon = /* #__PURE__ */ createIconComponent(IconCopy);
export const CurvedArrowIcon = /* #__PURE__ */ createIconComponent(IconCurvedArrow);
export const DescriptionIcon = /* #__PURE__ */ createIconComponent(IconDescription);
export const EarthOutlineIcon = /* #__PURE__ */ createIconComponent(IconEarthOutline);
export const EmailMonitorIcon = /* #__PURE__ */ createIconComponent(IconEmailMonitor);
export const EmailPhoneIcon = /* #__PURE__ */ createIconComponent(IconEmailPhone);
export const ExclamationTriangleIcon = /* #__PURE__ */ createIconComponent(IconExclamationTriangle);
export const EyeIcon = /* #__PURE__ */ createIconComponent(IconEye);
export const EyeClosedIcon = /* #__PURE__ */ createIconComponent(IconEyeClosed);
export const FaqIcon = /* #__PURE__ */ createIconComponent(IconFaq);
export const FilterIcon = /* #__PURE__ */ createIconComponent(IconFilter);
export const FilterHorizontalIcon = /* #__PURE__ */ createIconComponent(IconFilterHorizontal);
export const FlagInfoIcon = /* #__PURE__ */ createIconComponent(IconFlagInfo);
export const GiftWrappingIcon = /* #__PURE__ */ createIconComponent(IconGiftWrapping);
export const GlobeIcon = /* #__PURE__ */ createIconComponent(IconGlobe);
export const HeartFilledIcon = /* #__PURE__ */ createIconComponent(IconHeartFilled);
export const HeartIcon = /* #__PURE__ */ createIconComponent(IconHeart);
export const InfoIcon = /* #__PURE__ */ createIconComponent(IconInfo);
export const InfoOutlineIcon = /* #__PURE__ */ createIconComponent(IconInfoOutline);
export const LampIcon = /* #__PURE__ */ createIconComponent(IconLamp);
export const LayerIcon = /* #__PURE__ */ createIconComponent(IconLayer);
export const LiveLocationIcon = /* #__PURE__ */ createIconComponent(IconLiveLocation);
export const LockIcon = /* #__PURE__ */ createIconComponent(IconLock);
export const CheckMarkLockIcon = /* #__PURE__ */ createIconComponent(IconCheckMarkLock);
export const LogoutIcon = /* #__PURE__ */ createIconComponent(IconLogout);
export const MailIcon = /* #__PURE__ */ createIconComponent(IconMail);
export const MapIcon = /* #__PURE__ */ createIconComponent(IconMap);
export const MapMarkerIcon = /* #__PURE__ */ createIconComponent(IconMapMarker);
export const MailOutlineIcon = /* #__PURE__ */ createIconComponent(IconMessage);
export const NavigationIcon = /* #__PURE__ */ createIconComponent(IconNavigation);
export const NotAvailableIcon = /* #__PURE__ */ createIconComponent(IconNotAvailable);
export const PdfCheckIcon = /* #__PURE__ */ createIconComponent(IconPdfCheck);
export const PdfIcon = /* #__PURE__ */ createIconComponent(IconPdf);
export const PencilIcon = /* #__PURE__ */ createIconComponent(IconPencil);
export const PhoneIcon = /* #__PURE__ */ createIconComponent(IconPhone);
export const PhoneOutlineIcon = /* #__PURE__ */ createIconComponent(IconPhoneOutline);
export const PlusIcon = /* #__PURE__ */ createIconComponent(IconPlus);
export const PriceIcon = /* #__PURE__ */ createIconComponent(IconPrice);
export const PriceFrancIcon = /* #__PURE__ */ createIconComponent(IconPriceFranc);
export const ProfileIcon = /* #__PURE__ */ createIconComponent(IconProfile);
export const QrCodeIcon = /* #__PURE__ */ createIconComponent(IconQrCode);
export const QuestionIcon = /* #__PURE__ */ createIconComponent(IconQuestion);
export const RedirectIcon = /* #__PURE__ */ createIconComponent(IconRedirect);
export const ReturnArrowIcon = /* #__PURE__ */ createIconComponent(IconReturnArrow);
export const ReviewIcon = /* #__PURE__ */ createIconComponent(IconReview);
export const SailboatIcon = /* #__PURE__ */ createIconComponent(IconSailboat);
export const ReturnIcon = /* #__PURE__ */ createIconComponent(IconReturn);
export const SearchIcon = /* #__PURE__ */ createIconComponent(IconSearch);
export const SettingsIcon = /* #__PURE__ */ createIconComponent(IconSettings);
export const ShareIcon = /* #__PURE__ */ createIconComponent(IconShare);
export const ShoppingCartIcon = /* #__PURE__ */ createIconComponent(IconShoppingCart);
export const SmileyIndifferentIcon = /* #__PURE__ */ createIconComponent(IconSmileyIndifferent);
export const SmileySadIcon = /* #__PURE__ */ createIconComponent(IconSmileySad);
export const SmileyHappyIcon = /* #__PURE__ */ createIconComponent(IconSmileyHappy);
export const SmileySmirkIcon = /* #__PURE__ */ createIconComponent(IconSmileySmirk);
export const SmileyUnhappyIcon = /* #__PURE__ */ createIconComponent(IconSmileyUnhappy);
export const StarIcon = /* #__PURE__ */ createIconComponent(IconStar);
export const ThumbIcon = /* #__PURE__ */ createIconComponent(IconThumb);
export const ThumbOutlineIcon = /* #__PURE__ */ createIconComponent(IconThumbOutline);
export const TicketIcon = /* #__PURE__ */ createIconComponent(IconTicket);
export const TicketsOutlineThickIcon = /* #__PURE__ */ createIconComponent(IconTicketsOutlineThick);
export const TicketsOutlineThinIcon = /* #__PURE__ */ createIconComponent(IconTicketsOutlineThin);
export const TicketWithValueIcon = /* #__PURE__ */ createIconComponent(IconTicketWithValue);
export const UserCoupleIcon = /* #__PURE__ */ createIconComponent(IconUserCouple);
export const UserGroupIcon = /* #__PURE__ */ createIconComponent(IconUserGroup);
export const UserIcon = /* #__PURE__ */ createIconComponent(IconUser);
export const UserOutlineIcon = /* #__PURE__ */ createIconComponent(IconOutlineUser);
export const UserOutlineFilledIcon = /* #__PURE__ */ createIconComponent(IconOutlineUserFilled);
export const NotificationAlertIcon = /* #__PURE__ */ createIconComponent(IconNotificationAlert);
export const TicketDetailsIcon = /* #__PURE__ */ createIconComponent(IconTicketDetails);
export const TicketExchangeIcon = /* #__PURE__ */ createIconComponent(IconTicketExchange);
export const TouchIcon = /* #__PURE__ */ createIconComponent(IconTouch);
export const TrampolineIcon = /* #__PURE__ */ createIconComponent(IconTrampoline);
export const TrashIcon = /* #__PURE__ */ createIconComponent(IconTrash);
export const AlpacaIcon = /* #__PURE__ */ createIconComponent(IconAlpaca);
export const ArtIcon = /* #__PURE__ */ createIconComponent(IconArt);
export const SteeringWheelIcon = /* #__PURE__ */ createIconComponent(IconSteeringWheel);
export const DinnerIcon = /* #__PURE__ */ createIconComponent(IconDinner);
export const FireworksIcon = /* #__PURE__ */ createIconComponent(IconFireworks);
export const FlyIcon = /* #__PURE__ */ createIconComponent(IconFly);
export const HealthIcon = /* #__PURE__ */ createIconComponent(IconHealth);
export const SportIcon = /* #__PURE__ */ createIconComponent(IconSport);
export const SurfIcon = /* #__PURE__ */ createIconComponent(IconSurf);
export const TentIcon = /* #__PURE__ */ createIconComponent(IconTent);
export const TravelIcon = /* #__PURE__ */ createIconComponent(IconTravel);
export const ScreenIcon = /* #__PURE__ */ createIconComponent(IconScreen);
export const ListViewIcon = /* #__PURE__ */ createIconComponent(IconListView);
export const LocationDetailsIcon = /* #__PURE__ */ createIconComponent(IconLocationDetails);
export const TileViewIcon = /* #__PURE__ */ createIconComponent(IconTileView);
export const BallonIcon = /* #__PURE__ */ createIconComponent(IconBallon);
export const ForwardClockIcon = /* #__PURE__ */ createIconComponent(IconForwardClock);
export const VarityIcon = /* #__PURE__ */ createIconComponent(IconVarity);
export const TripIcon = /* #__PURE__ */ createIconComponent(IconTrip);
export const TripBoldIcon = /* #__PURE__ */ createIconComponent(IconTripBold);
export const WaterSportsIcon = /* #__PURE__ */ createIconComponent(IconWaterSports);
export const WaypointIcon = /* #__PURE__ */ createIconComponent(IconWaypoint);
export const OliveLeafIcon = /* #__PURE__ */ createIconComponent(IconOliveLeaf);
export const PaintIcon = /* #__PURE__ */ createIconComponent(IconPaint);
export const HeadsetIcon = /* #__PURE__ */ createIconComponent(IconHeadset);
export const HalfClockIcon = /* #__PURE__ */ createIconComponent(IconHalfClock);
export const SortingIcon = /* #__PURE__ */ createIconComponent(IconSorting);
export const WarrantyBadgeIcon = /* #__PURE__ */ createIconComponent(IconWarrantyBadge);
export const SupportIcon = /* #__PURE__ */ createIconComponent(IconSupport);
export const DownloadIcon = /* #__PURE__ */ createIconComponent(IconDownload);
export const ClubDiscountIcon = /* #__PURE__ */ createIconComponent(IconClubDiscount);
export const SignpostIcon = /* #__PURE__ */ createIconComponent(IconSignpost);
export const MaximizeIcon = /* #__PURE__ */ createIconComponent(IconMaximize);
// Social icons
export const SocialWhatsAppIcon = /* #__PURE__ */ createIconComponent(IconWhatsApp);
export const SocialFacebookRoundIcon = /* #__PURE__ */ createIconComponent(IconFacebook);
export const SocialInstagramIcon = /* #__PURE__ */ createIconComponent(IconInstagram);
export const SocialPinterestIcon = /* #__PURE__ */ createIconComponent(IconPinterest);
export const SocialTiktokIcon = /* #__PURE__ */ createIconComponent(IconTiktok);
export const SocialYoutubeIcon = /* #__PURE__ */ createIconComponent(IconYoutube);
